import { defineStore } from "pinia";
import { MatchConfig } from '@/components/StartPanel/config';
import { sleep } from "@/utils";
import { GameStatus } from "@/enums/netEnum";
interface GameState {
    /**
     * 匹配状态
     */
    matchStatus: boolean,
    /**
     * 游戏状态
     */
    gameStatus: GameStatus | 'ROBOT',
    /**
     * 是否显示游戏中图标
     */
    showInGameIcon: boolean,
    /**
     * 匹配的信息
    */
    matchItem: Nullable<MatchConfig>,
    /**
     * 是否是锦标赛
     */
    isChampionship: boolean
};

export const useGameStore = defineStore({
    id: 'app-game',
    persist: true,
    state: (): GameState => ({
        matchStatus: false,
        matchItem: null,
        gameStatus: GameStatus.ONLINE,
        showInGameIcon: false,
        isChampionship: false
    }),
    actions: {
        async setMatchStatus(status: boolean) {
            this.matchStatus = status;
            await sleep(500);
            !status && this.clearMatchItem();
        },
        setMatchItem(item: MatchConfig) {
            this.matchItem = item;
        },
        clearMatchItem() {
            this.matchItem = null;
        },
        setShowInGameIcon(status: boolean) {
            this.showInGameIcon = status;
        },
        setGameType(type = "normal") {
            this.isChampionship = type == "championship";
        },
        setGameStatus(status: GameStatus | 'ROBOT') {
            this.gameStatus = status;
        },
    }
});